"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_component_1 = require("../../map.component");
const _4d_mapper_1 = require("4d-mapper");
const map_service_1 = require("../../../../commons/map.service");
const app_service_1 = require("../../../../commons/app.service");
const BaseComponent_1 = require("../../../../commons/BaseComponent");
const global_1 = require("../../../../commons/global");
const entity_helper_service_1 = require("../../../../service/entity-helper.service");
const application_events_service_1 = require("../../../../xs/services/events/application-events.service");
const Cesium = window.Cesium;
class PPListComponent extends BaseComponent_1.BaseComponent {
    constructor(route, router, fourD, snackBar, dialog, entityHelper, mapService, service, applicationEvents) {
        super(router, snackBar, dialog);
        this.route = route;
        this.router = router;
        this.fourD = fourD;
        this.entityHelper = entityHelper;
        this.mapService = mapService;
        this.service = service;
        this.rovers = [];
        this.stations = [];
        console.log('pp.component CONSTRUCTOR', this);
    }
    init() {
        // position aprtenrs only mod, just enabled this on labs!
        return;
        this.interval = setInterval(() => this.refreshSensors(), 30000);
    }
    destroy() {
        clearInterval(this.interval);
    }
    clickedMap(movement, rightClick, checkedPosition) {
        return map_component_1.ClickDisplay.None;
    }
    becameActive(mapComp) {
        this.mapComp = mapComp;
        this.fourD.onReady().subscribe(_ => this.mapService.onReady().subscribe(_ => this.refreshSensors()));
    }
    becameInactive(mapComp) {
    }
    refreshSensors() {
        var apiType = this.mapService.fourD.apis.find(a => a.processorImpl == global_1.APITypes.PositionPartners.IMPL);
        if (!apiType || !apiType.id) {
            return;
        }
        this.fourD.V.api('/remote/' + apiType.id + '/api/v1/overview').subscribe(s => {
            this.mapService.annotations = this.mapService.annotations.filter(a => this.rovers.indexOf(a) == -1 && this.stations.indexOf(a) == -1);
            this.rovers = s.rovers.map((r, i) => {
                var a = new _4d_mapper_1.Annotation(this.fourD.V);
                a.id = -i;
                a.name = r.name;
                a['attributes'] = Object.keys(r).map(k => {
                    return {
                        key: k,
                        value: r[k]
                    };
                });
                a.annotationMode = 'pp';
                a.ulat = r.position.latitude * 180 / Math.PI;
                a.llat = r.position.latitude * 180 / Math.PI;
                a.ulng = r.position.longitude * 180 / Math.PI;
                a.llng = r.position.longitude * 180 / Math.PI;
                //  a.uheight = r.position.altitude
                //  a.lheight = 300
                a['icon'] = 'crosshairs';
                this.mapService.annotations.push(a);
                this.mapService.helper.addPlottable(a).subscribe(res => res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable));
                return a;
            });
            this.stations = s.stations.map((r, i) => {
                var a = new _4d_mapper_1.Annotation(this.fourD.V);
                a.id = -(1 + i) * 10000;
                a.name = r.name;
                a['attributes'] = Object.keys(r).map(k => {
                    return {
                        key: k,
                        value: r[k]
                    };
                });
                a.annotationMode = 'pp';
                a.ulat = r.position.latitude * 180 / Math.PI;
                a.llat = r.position.latitude * 180 / Math.PI;
                a.ulng = r.position.longitude * 180 / Math.PI;
                a.llng = r.position.longitude * 180 / Math.PI;
                //  a.uheight = r.position.altitude
                // a.lheight = 300
                a['icon'] = 'wifi';
                this.mapService.annotations.push(a);
                this.mapService.helper.addPlottable(a).subscribe(res => res.object.pin.billboard.image = this.entityHelper.getPinImage(res.plottable));
                return a;
            });
        }, e => this.openSnackBarError('GENERIC.CONNECT_ERROR2' + e));
    }
}
exports.PPListComponent = PPListComponent;
